import api from '../config/api';

export const subscribe = (body) => api.post('/v1/ecommerce/subscriptions', body);
export const invite = (body) => api.post('/v1/ecommerce/family/redeem', body);
